import { useStaticQuery, graphql } from 'gatsby'
import { useBlogAuthors } from '@helpers-blog'

// :::: GET all the articles and returning Authors by selected article ::::
export const getSelectedArticleAuthors = title => {
  const { blog, video, event } = useStaticQuery(allArticlesQuery)
  const list = [...blog.nodes, ...video.nodes, ...event.nodes]
  const selectedArticle = list.find(article => article.title === title)
  return selectedArticle?.authors || []
}

const allArticlesQuery = graphql`
  query {
    blog: allStrapiBlog {
      nodes {
        id
        title
        authors {
          id
          name
          title
          slug
          updatedAt
          social {
            name
            url
          }
        }
      }
    }
    video: allStrapiVideo {
      nodes {
        id
        title
        authors {
          id
          name
          title
          slug
          updatedAt
          social {
            name
            url
          }
        }
      }
    }

    event: allStrapiEvent {
      nodes {
        id
        title
        authors {
          id
          name
          title
          slug
          updatedAt
          social {
            name
            url
          }
        }
      }
    }
  }
`
// :::: Attach thumbnail ::::
export const attachThumbnail = authors => {
  authors.forEach(author => {
    const match = useBlogAuthors().find(
      authorWithThumbnail => authorWithThumbnail.name === author.name
    )
    author['thumbnail'] = match?.thumbnail
  })
}
